import { ColumnVO } from '@ag-grid-community/core'

export interface GroupModel<T> {
  keys: Array<keyof T>
  fields: {
    field: keyof T
  }[]
}

/** Convert ag-grid groupingModel to Helios backend groupingModel */
export function convertGrouping<T>(rowGroupCols: ColumnVO[], keys: string[]) {
  return {
    keys,
    fields: rowGroupCols.map(col => ({ field: col.field ?? col.id })),
  } as GroupModel<T>
}
